import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "./redux/store";
import i18n from "./i18n"; // Import the i18n configuration
import { I18nextProvider } from "react-i18next";
import { ThemeProvider } from "./components/ui/theme-provider";
import App from "./App";
import "./index.css";
import "./satoshi.css";
import "./fonts.css";
import "leaflet/dist/leaflet.css";
// import { PersistGate } from 'redux-persist/integration/react';

// Auto-unregister service workers in development to prevent Workbox logs
import "./utils/unregisterSW.js";

ReactDOM.createRoot(document.getElementById("root")).render(
	// <React.StrictMode> // Commented out to prevent double API calls in development
	<ThemeProvider defaultTheme="light" storageKey="vite-ui-theme">
		<I18nextProvider i18n={i18n}>
			<Provider store={store}>
				<BrowserRouter>
					<App />
				</BrowserRouter>
			</Provider>
		</I18nextProvider>
	</ThemeProvider>
	// </React.StrictMode>
);
